export const FETCH_USER_TYPES = 'FETCH_USER_TYPES'
export const CLEAR = 'CLEAR'

export default {
  FETCH_USER_TYPES,
  CLEAR
}
